/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const holidaySchemesSyncRequestSchema = z.object({
  instanceId: z.string().min(1),
});
